console.log('js/sticky.js -> v0.1.0');

var __ctaStickyMode = 0; // 0 - not sticky, 1 - sticky while scrolling, 2 - sticky above footer
var __ctaStickyLeft = -1;


var __ctaStickyClasses = "";

function updateMainCTA0() {
	var $el = $("#sticky-reserve");
	if(window.matchMedia('all and (max-width: 480px)').matches){
		var gtt = $('.gototop-btn');
		if($el && $el.position() && $el.position().top && $el.position().top > $(window).height()){
			gtt.css('bottom','');
		}else{
			gtt.css('bottom',$el.height() + 30 + 'px');
		};
	};
	if ($el.length > 0) {
		var mode = __ctaStickyMode;
		var $window = $(window);
		var $topAnchor = $("#sticky-top-anchor");
		var $limit = $("footer");

		if (($topAnchor.length > 0) && ($limit.length > 0)) {
			var topWindow = $window.scrollTop();
			var botWindow = topWindow + $window.innerHeight();

			var classes = "sticky sticky-bot box white fixed";

			var topAnchor = $topAnchor.offset().top;
			if ((topAnchor <= topWindow) || (topAnchor > (botWindow - $el.outerHeight()))) {
				if (mode == 0)
					$el.addClass(classes);

				var limitMargin = parseInt(($limit.css("marginTop") || "").replace('px', ''));
				var topLimit = $limit.offset().top - limitMargin;

				if (botWindow >= topLimit) {
					if (mode != 2) {
						$el.removeClass("sticky");
						$el.addClass("sticky-abs");
						$el.css({ 'bottom': 0 });
					}
					mode = 2;
				} else {
					if (mode == 2) {
						$el.removeClass("sticky-abs");
						$el.addClass("sticky");
					}

					if (mode != 1)
						$el.css({ 'bottom': 0 });
					mode = 1;
				}

				var left = $el.parent().offset().left - $el.offsetParent().offset().left;
				if (left != __ctaStickyLeft) {
					__ctaStickyLeft = left;
					$el.css({ 'left': left });
				}
			} else {
				if (mode != 0)
					$el.removeClass(classes);
				mode = 0;
			}
			__ctaStickyMode = mode;
		}
	}
}


var datePicked_ = false;
var dateShown_ = false;

function initStickyCTA() {
	$(window).scroll(updateMainCTA0);
	$(window).resize(updateMainCTA0);
	$(window).bind("touchmove", updateMainCTA0);
	$(window).bind("touchend", updateMainCTA0);

	var $datepicker = $('#listing_query_arrival_date.date-picker');
	$datepicker.on('changeDate', function() {
		if (dateShown_)
			datePicked_ = true;
	});

	$datepicker.on('click', function() {
		dateShown_ = true;
	});

	$datepicker.on('show', function() {
		dateShown_ = true;
	});

	var clickHandler = function (event) {

		var $el = $("#sticky-reserve");
		var $window = $(window);
		var $topAnchor = $("#sticky-top-anchor");

		var topWindow = $window.scrollTop();
		var botWindow = topWindow + $window.innerHeight();

		const offset = $topAnchor.offset()

		if (offset && offset.top) {
			var anchorTop = offset.top;

			var shouldScroll = (anchorTop <= topWindow) || (anchorTop > (botWindow - ($el.outerHeight() - ($("#listing_side_list").outerHeight()*0.80))));

			if (shouldScroll) {
				var top = 5 + anchorTop + $el.outerHeight() - $window.innerHeight();

				$('html, body').animate({ scrollTop: top }, 400);
				$(this).blur();

				return false;
			}
		}
	}

	$("#inquiry-query-submit, #reservation-query-submit").on('click', clickHandler);
	$("#inquiry-query-submit, #reservation-query-submit").on('touchstart', clickHandler);

	setTimeout(updateMainCTA0, 150);
}

$(function(){

	var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	if(iOS && $(window).width() < 1025 && $("#sticky-reserve").length){
		$(document).on('scroll', function(){
			clearTimeout(window.ios_fixed_cta_fix_to);
			$("#sticky-reserve").addClass('ios_fixed_cta_fix');
			window.ios_fixed_cta_fix_to = setTimeout(function(){
				$("#sticky-reserve").removeClass('ios_fixed_cta_fix');
			},50);
		});
	};

})
